import sdl from '@jds/react-generated-sdl/JDSSidePanelItem';
import type { JDSSidePanelItemProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic } from '../logic';

const Component = (props: JDSSidePanelItemProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const {
    type = 'entry',
    showSuffix = true,
    ariaLabel = props.title?.toString(),
    custom = '',
    ...rest
  } = props as any;
  return createComponent(
    json,
    { type, showSuffix, ariaLabel, ...rest },
    'JDSSidePanelItem',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const SidePanelItem = withLogic(
  Component
) as React.FC<JDSSidePanelItemProps> & { slotName?: string };

SidePanelItem.displayName = 'SidePanelItem';
SidePanelItem.slotName = 'jds_side_panel_item';

export { SidePanelItem, type JDSSidePanelItemProps };
